export const MAX_CPP_CREATOR_LEVEL = 25

export const CPP_AVATAR_FRAME_URLS = [
    'https://static.weryai.com/image/weryai_33da23220e711eaa2129510175c47a78.webp',
    'https://static.weryai.com/image/weryai_61ca0cad479d7b7bb774d7c033ae5b13.webp',
    'https://static.weryai.com/image/weryai_a0f23faef1f1362ab6ba8fe8c7631e7c.webp',
    'https://static.weryai.com/image/weryai_c8e3f893625e1bc8d06f249079614a97.webp',
    'https://static.weryai.com/image/weryai_baa378c122dffdf303098dd33830c9c9.webp',
    'https://static.weryai.com/image/weryai_044c8a3ae25cc86d62d02214131987f9.webp',
    'https://static.weryai.com/image/weryai_d9e3a93ad2c1b09f193b399cae06131b.webp',
    'https://static.weryai.com/image/weryai_0f882438a3110dcb29a18b443242452f.webp',
    'https://static.weryai.com/image/weryai_cb07799a23549991e4b67511d89ffb0f.webp',
    'https://static.weryai.com/image/weryai_9d04a78e2395bf5db8ac56117df7242c.webp',
    'https://static.weryai.com/image/weryai_91f7d5a03b8840ff3b5b956b22e6c186.webp',
    'https://static.weryai.com/image/weryai_207b375a35652e982106e4c7dc9c2957.webp',
    'https://static.weryai.com/image/weryai_b2f408c93a9533767129737429d66220.webp',
    'https://static.weryai.com/image/weryai_9d4b545923b15dea6e611bd88e13c4dc.webp',
    'https://static.weryai.com/image/weryai_0fbc93a445656bacb2cd4cfc8ff30ea7.webp',
    'https://static.weryai.com/image/weryai_060b2ac5d8ff861a5ce9ca6675812cbf.webp',
    'https://static.weryai.com/image/weryai_35f1fa75d02901d6ac4f41bc9e40a78f.webp',
    'https://static.weryai.com/image/weryai_60bda008c1e12f85d30dc49943e6d433.webp',
    'https://static.weryai.com/image/weryai_55fbd768a68ed362c85025793edc6536.webp',
    'https://static.weryai.com/image/weryai_3c976561331015c3abefd2469868ab8e.webp',
    'https://static.weryai.com/image/weryai_f2d0b44f65ea92e76c748fa46e846865.webp',
    'https://static.weryai.com/image/weryai_dbc7d660bcc46123238df7efe8f79d5b.webp',
    'https://static.weryai.com/image/weryai_5c3a7fc5673641f07dfb39300e149414.webp',
    'https://static.weryai.com/image/weryai_69c485241b3ee1b55e10e562f12a9168.webp',
    'https://static.weryai.com/image/weryai_2627722ac484435f04e8b1bcbeacfa0e.webp',
] as const

export const normalizeCppCreatorLevel = (level?: number | null) => {
    if (!Number.isFinite(level)) return 1
    return Math.min(
        MAX_CPP_CREATOR_LEVEL,
        Math.max(1, Math.floor(level as number))
    )
}

export const getCppAvatarFrameUrl = (level?: number | null) =>
    CPP_AVATAR_FRAME_URLS[normalizeCppCreatorLevel(level) - 1]
